/**
 * @file BackupSwitchRow.tsx
 * @description Строка-переключатель форм бэкапа (phase19.26 шаг 7.1): вся
 * строка — `<label>` и нажимаемая область ≥ 48px, а не только сам Switch
 * (по образцу `SourceRow` в `BackupSourcesFields`). Общий `ui/switch` не меняем.
 */

import { Switch } from "../../ui/switch";
import { cn } from "@/lib/utils";

interface Props {
  label: string;
  hint: string;
  checked: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
  className?: string;
}

export function BackupSwitchRow({ label, hint, checked, onChange, disabled, className }: Props) {
  return (
    // Клик по любой точке строки переключает: label передаёт его вложенной кнопке Switch.
    <label
      className={cn(
        "flex min-h-12 items-center justify-between gap-3 rounded-xl bg-surface-low px-3 py-2",
        disabled ? "cursor-not-allowed opacity-70" : "cursor-pointer",
        className,
      )}
    >
      <span className="flex min-w-0 flex-col">
        <span className="text-sm font-medium text-on-surface">{label}</span>
        <span className="text-xs text-on-surface-variant">{hint}</span>
      </span>
      <Switch checked={checked} onCheckedChange={(v) => onChange(Boolean(v))} disabled={disabled} />
    </label>
  );
}
